// extracted by mini-css-extract-plugin
export default {"p_tye":"_75a9ee6636","slcted":"b178eb10f0","slc_color":"_986b50440b","item_p":"_71188a62c8","r0":"_9146e6b0bb"};